export const imageUrl = image => (`url('${image}')`);